<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="Campaign" :title="`Invoices By Campaign`" />

        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table
                  dense
                  :headers="headers"
                  :expanded.sync="expanded"
                  show-expand
                  :itemsPerPage="Campaign.length"
                  hide-default-footer
                  :items="Campaign"
                >
                  <template v-slot:item="{ item, isExpanded, expand }">
                    <tr>
                      <td class="text-left ">
                        <v-btn
                          class="no-print"
                          @click="expand(true)"
                          icon
                          v-if="!isExpanded"
                          ><v-icon>mdi-chevron-down</v-icon></v-btn
                        >
                        <v-btn
                          class="no-print"
                          @click="expand(false)"
                          icon
                          v-if="isExpanded"
                          ><v-icon>mdi-chevron-up</v-icon></v-btn
                        >
                      </td>
                      <td class="text-left">{{ item.name }}</td>
                      <td class="text-right">{{ item.PledgeTotal | currency }}</td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0">
                      <v-card color="#F3F8FC" flat>
                        <v-card-text class="title">
                          <Invoice :CampaignId="item.id" :start="start" :end="end" ></Invoice>
                        </v-card-text>
                      </v-card>
                    </td>
                  </template>
                  <template
                    v-slot:body.append="{ headers }"
                    v-if="Campaign.length > 0"
                  >
                    <tr>
                      <td></td>
                      <td
                        :colspan="headers.length - 3"
                        class="text-right font-weight-bold"
                      >
                        Total
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ total | currency }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import campaignService from "@/modules/Campaign/service";
import Invoice from "@/modules/ReportView/components/invoice/components/Invoice.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isLoading: true,
      Campaign: null,
      start: null,
      end: null,
      expanded: [],
      headers: [
        { text: "", value: "data-table-expand" },
        {
          text: "Campaign Name",
          align: "left",
          value: "name",
          sortable: false,
        },

        {
          text: "Amount",
          align: "right",
          value: "PledgeTotal",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    total() {
      let total = 0;
      this.Campaign.map((row) => {
        total += row.PledgeTotal;
      });

      return total;
    },
  },
  created() {
    this.loadData();
    if (!this.currentBusiness) this.initUser();
  },
  components: { ReportViewBar, Invoice },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    loadData() {
      this.start = this.$route.query.start;
      this.end = this.$route.query.end;
      return campaignService
        .getAll({start: this.start, end: this.end})
        .then((response) => {
          this.$Progress.finish();
          this.Campaign = response.data;
          document.title = `Report - Campaign Invoice`;

          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
</style>
